import React from 'react';
import { Button } from '@material-ui/core';
import { AuthRoles, readableSchemeTypes, Roles, SchemeTypes } from 'config';
import { Control, useForm, DeepMap, FieldError } from 'react-hook-form';
import TranslatedText from '../../../../components/atoms/translated_text';
import {
  AppSelect,
  AppTextField,
} from '../../../../components/molecules/form_controls';
import GridLayout from '../../../../components/molecules/grid_layout';
import { Translations } from '../../configuration';
import _ from 'lodash';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import * as VatReturnsReceivedListSelectors from 'redux/reducers/vatreturns_received_list_reducer/selectors';

interface FormFields {
  vat_num: string | null;
  originatingCountry: string | null;
  schemeType: string | null;
}

interface IProps {
  vat_number: string | null;
  originatingCountry: string | null;
  schemeType: string | null;
  role: Roles;
}

const FilterForm = (props: IProps) => {
  const history = useHistory();

  const defaultValues = {
    vat_num: props.vat_number ? props.vat_number : null,
    originatingCountry: props.originatingCountry
      ? props.originatingCountry
      : null,
    schemeType: props.schemeType ? props.schemeType : null,
  };
  const { control, errors, handleSubmit, reset } = useForm<FormFields>({
    defaultValues: defaultValues,
  });

  const onSubmit = (data: any) => {
    let query = [];
    if (data.vat_num)
      query.push({
        key: 'vat_num',
        value: data.vat_num,
      });
    if (data.originatingCountry)
      query.push({
        key: 'originatingCountry',
        value: data.originatingCountry,
      });
    if (data.schemeType)
      query.push({
        key: 'schemeType',
        value: data.schemeType,
      });
    let queryString = '';
    query.map((query, index) => {
      if (index == 0) queryString += `?${query.key}=${query.value}`;
      else queryString += `&${query.key}=${query.value}`;
    });
    history.push(NavigationConfig.vatReturnReceivedPage().path + queryString);
  };

  const clearFilter = () => {
    history.push(NavigationConfig.vatReturnReceivedPage().path);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ marginBottom: '0.6rem' }}>
      <GridLayout
        elements={
          [
            {
              element: renderVatNumberField(errors, control),
              size: 3,
              id: 'vatNumber',
            },
            {
              element: renderOriginatingCountryField(errors, control),
              size: 3,
              id: 'originatingCountry',
            },
            {
              element: renderSchemeTypeField(errors, control),
              size: 3,
              id: 'schemeType',
            },
            // {
            //   element: <span></span>,
            //   size: 1,
            //   id: 'space',
            // },
            {
              element: (
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginRight: '0.25rem',
                    }}
                  >
                    <TranslatedText textMap={Translations.search} />
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{
                      width: '47%',
                      marginTop: '0.6rem',
                      marginLeft: '0.25rem',
                    }}
                    onClick={clearFilter}
                  >
                    <TranslatedText textMap={Translations.clear} />
                  </Button>
                </div>
              ),
              size: 3,
              id: 'search',
            },
            // {
            //   element: (
            //     <Button
            //       variant="contained"
            //       color="primary"
            //       style={{ width: '100%', marginTop: '0.5rem', marginBottom: '1rem' }}
            //       onClick={clearFilter}
            //     >
            //       <TranslatedText textMap={Translations.clear} />
            //     </Button>
            //   ),
            //   size: 1,
            //   id: 'clear',
            // },
          ] as any
        }
      />
    </form>
  );
};

const renderVatNumberField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  return (
    <AppTextField
      variant="outlined"
      fullWidth
      id="vat_num"
      label={<TranslatedText textMap={Translations.vat_number} />}
      error={'vat_num' in errors}
      name="vat_num"
      control={control}
      rules={{}}
      helperText={errors.vat_num && errors.vat_num.message}
    />
  );
};

const renderOriginatingCountryField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  let countries =
    VatReturnsReceivedListSelectors.useGetMemberStateExcludeCyprusCountries();
  let select_countries = [];
  select_countries.push({
    id: '',
    label: 'MSID Country',
  });
  if (countries && countries.length > 0)
    for (let country of countries)
      select_countries.push({
        id: country.code,
        label: `${country.code} - ${country.description}`,
      });
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.originatingCountry} />}
      id="originatingCountry"
      name="originatingCountry"
      error={'originatingCountry' in errors}
      control={control}
      rules={{}}
      options={select_countries as any}
      helperText={
        errors.originatingCountry && errors.originatingCountry.message
      }
    />
  );
};

const renderSchemeTypeField = (
  errors: DeepMap<FormFields, FieldError>,
  control: Control<FormFields>
) => {
  const schemeTypes = ['MOSS', 'VOES', 'IMPORT'];
  let select_options = [];
  select_options.push({
    id: '',
    label: Translations.schemeType.English,
  });
  for (let schemeType of schemeTypes) {
    select_options.push({
      id: schemeType,
      label: _.get(readableSchemeTypes, schemeType),
    });
  }
  return (
    <AppSelect
      variant="outlined"
      fullWidth
      label={<TranslatedText textMap={Translations.schemeType} />}
      id="schemeType"
      name="schemeType"
      error={'schemeType' in errors}
      control={control}
      rules={{}}
      options={select_options as any}
      helperText={errors.schemeType && errors.schemeType.message}
    />
  );
};

export default FilterForm;
